// @flow
import types from "./types";
import type {CurrentRide, WalkingMap} from "./reducers";
import type {DriverPhoneData} from "./utils";

const rideDataUpdate = (rideData: CurrentRide) => ({
    type: types.RIDE_DATA_UPDATE,
    payload: rideData,
});

const rideDataClear = () => ({type: types.RIDE_DATA_CLEAR});

const handleWalkingMapRequestSuccess = (walkingMap: WalkingMap) => ({
    type: types.RIDE_WALKINGMAP_UPDATE,
    payload: walkingMap,
});

const requestedWalkingMap = () => ({type: types.RIDE_WALKINGMAP_REQUEST});

const setDriverPhone = (driverPhoneData: DriverPhoneData) => ({
    type: types.RIDE_DRIVER_PHONE,
    payload: driverPhoneData.driver_phone
});

export default {
    rideDataUpdate,
    rideDataClear,
    handleWalkingMapRequestSuccess,
    requestedWalkingMap,
    setDriverPhone,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentRide/actions.js